import JalanExperience from './JalanExperience/JalanExperience';

// reservationページのじゃらん体験
if (document.querySelector('[name="jalan-form"]') !== null) {
  const jalanExperience = new JalanExperience({
    requestBaseURI: '/jalan_experiences',
    prefId: '090000', // kenCd
    areaId: '', // lrgCd
    cityId: '', // cityCd
    itemSizePerPage: 24,
    initPageNum: 1,
    sortType: 1,
    view: {
      noImagePath: document.querySelector('[data-role="jalan-no-img-path"]').src,
      sortButtonActiveClassName: 'bg-success',
      hideClassName: 'd-none',
    },
  });
}
